import { getSaleItems, type Sale } from '@src/domains/sales';

export interface SaleItemSummary {
  productName: string;
  sellerName: string;
  sellerLogoUrl: string | null;
  scheduleDate: string | null;
  scheduleTime: string | null;
}

/** Product, seller and schedule of the cart item the tariffs belong to. */
export const resolveSaleItemSummary = (sales: Sale[], saleItemId: string): SaleItemSummary | null => {
  const item = sales.flatMap(getSaleItems).find((saleItem) => saleItem.id === saleItemId);

  if (!item) {
    return null;
  }

  return {
    productName: item.product.name,
    sellerName: item.product.app.name,
    sellerLogoUrl: item.product.app.logoUrl ?? null,
    scheduleDate: item.scheduleDate,
    scheduleTime: item.formattedScheduleTimeMinutes,
  };
};
